//
//
//
//
//
//
//
//
//
//
//
//


import axios from '~/plugins/axios';

export default {
	name: 'Breadcrumbs',

	props: {
		crumbs: {
			type: Array,
			required: true
			//validator: val => val.length
		}
	},

	computed: {
		mobile: function mobile() {
			return this.$route.query.mobile;
		},
		homeLink: function homeLink() {
			if (this.$route.params.lang == 'en') return '/eng';else return '/';
		},
		homeTitle: function homeTitle() {
			return this.$store.state.settings.homeTitle;
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/Breadcrumbs.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/Breadcrumbs.vue
// module chunks = 0 1 2